import React, { useEffect, useState } from 'react'
import CustomModal from '../../../../Components/custom_components/CustomModal/CustomModal'
import CustomTable from '../../../../Components/custom_components/CustomTable/CustomTable'
import CustomBottomPagination from '../../../../Components/custom_components/CustomBottomPagination/CustomBottomPagination'
import { handlePaginationEntries } from '../../../../utils/pagination'
import { ErrorToast, SuccessToast } from '../../../../utils/toast'
import { useSelector } from 'react-redux'
import { hasPrivilege } from '../../../../utils/privileges'
import Loader from '../../../../Components/Loader/Loader'
import './InvoiceTableStyle.css'
import CustomConfirmModal from '../../../../Components/custom_components/CustomConfirmModal/CustomConfirmModal'
import UpdatePaymentStatusForm from '../UpdatePaymentStatusForm/UpdatePaymentStatusForm'
import InvoiceSearchFilter from '../InvoiceSearchFilter/InvoiceSearchFilter'
import { change_invoice_status, get_all_invoices_with_pagination, get_schedule_Invoice_Details, invoice_move_to_finance } from '../../../../config/ScheduleReportApis/scheduleReportApis'
import { Icons } from '../../../../utils/GlobalIcons'
import InvoiceListView from '../InvoiceListView/InvoiceListView'
import { getStatusColors } from '../../../../utils/constants'
import CustomTooltipWithoutRoundBorder from '../../../../Components/CustomActionButtonWithTooltip/CustomTooltipWithoutRoundBorder'
import ActionHistory from '../../../../Components/ActionHistory/ActionHistory'
import { fetchHistoryData } from '../../../../config/HistoryService/historyService'

function InvoiceTable() {
    const privileges = useSelector((state) => state.privileges.privileges);

    // State variables for managing schedule data, pagination, and modal states
    const [invoiceListing, setInvoiceListing] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItemPerPage, setTotalItemPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({ start: 0, end: 0, totalEntries: 0 });
    const [refresh, setRefresh] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const [filterValues, setFilterValues] = useState({

        invoice_number: '',
        submitted_by: '',
        submitted_from: '',
        submitted_to: '',
        PaymentStatus: 0, //Not paid =1, 1=Paid
        sentToClient: 0,
        invoice_status: '',

    }); // Define filter values state

    // FOR HANDLE THE CHECKBOX WHEN INVOICE AND PAYMENT BUTTON HJIDE AND SHOW BASED ON THE DROPDOWN
    const [currentDropdown, setcurrentDropdown] = useState({
        PaymentStatus: 0,
        sentToClient: 0,
    });

    const [isLoading, setIsLoading] = useState(false); // Loader state
    const [selectedIds, setSelectedIds] = useState([]); //FOR FORWARD THE SELECTED IDS INTO CLIENT

    const [submitModal, setSubmitModal] = useState({
        isOpen: false,
        id: '',
    });
    const [paySubmitModal, setPaySubmitModal] = useState({
        isOpen: false,
        id: '',
    });
    const [viewModal, setViewModal] = useState(false);
    const [invoiceList, setInvoiceList] = useState({});

    const [showHistory, setShowHistory] = useState(false); // history modal state
    const [historyData, setHistoryData] = useState([]);
    const [historyLoader, setHistoryLoader] = useState(false); // Loader state



    // Fetch schedule data on page change or refresh
    useEffect(() => {
        fetchInvoices();
    }, [pageNumber, totalItemPerPage, filterValues, refresh]);

    // Fetch schedule data from API
    const fetchInvoices = async () => {
        const formData = new FormData();
        formData.append('page', pageNumber);
        formData.append('pageItemcount', totalItemPerPage);

        // Append filter values to formData
        Object.keys(filterValues).forEach(key => formData.append(key, filterValues[key]));

        try {
            setIsLoading(true)
            const response = await get_all_invoices_with_pagination(formData);

            if (response?.status === "success") {
                setSelectedIds([]);
                const data = response.data;
                setInvoiceListing(data?.data);
                setTotalPages(data.last_page);
                setPagination(handlePaginationEntries(data.from, data.to, data.total));

            } else {
                setInvoiceListing([]);
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    };

    // Define the required permission actions
    const PERMISSION_ACTIONS = {
        view: 4,
        Send_to_client: 14,
        Mark_as_paid: 15,
        history: 6,
    };

    // Map permissions to boolean values based on privileges
    const userPermissions = {
        view: hasPrivilege(privileges, "Finances", 21, PERMISSION_ACTIONS.view),
        Send_to_client: hasPrivilege(privileges, "Finances", 21, PERMISSION_ACTIONS.Send_to_client),
        Mark_as_paid: hasPrivilege(privileges, "Finances", 21, PERMISSION_ACTIONS.Mark_as_paid),
        history: hasPrivilege(privileges, "Finances", 21, PERMISSION_ACTIONS.history),

    };
    const hasActionPermissions = userPermissions.view || userPermissions.history
    // Columns for the table
    const columns = [
        { title: "#", key: "key" },
        { title: "Invoice", key: "InvoicesNumber" },
        { title: "Amount", key: "Amount" },
        { title: "Submitted By", key: "SubmittedBy" },
        { title: "Submitted Date", key: "Submitteddate" },
        { title: "Client Name", key: "clientName" },
        {
            title: "Invoice Status",
            key: "InvoiceStatusName",
        },
        {
            title: "Payment Status",
            key: "PaymentStatus",
            render: (_, record) => {
                //  actual status text
                const statusText = record?.PaymentStatus === 1 ? 'Paid' : 'Not Paid';
                const style = getStatusColors(record?.PaymentStatus === 1 ? 1 : 2); //for styles based on status

                return (
                    <span className="status-badge" style={style}>
                        {statusText}
                    </span>
                );
            },
        },

        { title: "Actions", key: "actions", render: (text, row) => renderActions(row) },
    ].filter(column => column.key !== "actions" || hasActionPermissions); //removes the "Actions" column when hasActionPermissions is false

    // Render action icons for each schedule item
    const renderActions = (row) => (
        <div className="action-container">

            {userPermissions.view && <CustomTooltipWithoutRoundBorder title="View">
                <Icons.View className="view-action-icon" onClick={() => handleInvoiceModal(row?.id, 'view')} />
            </CustomTooltipWithoutRoundBorder>}

            {userPermissions.history && <CustomTooltipWithoutRoundBorder title="History">
                <Icons.History className="history-action-icon" onClick={() => handleHistoryModal(true, row?.id)} />
            </CustomTooltipWithoutRoundBorder>}
        </div>
    );

    // Map the schedule data into table rows
    const rows = () => invoiceListing?.map((item, index) => ({
        key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
        id: item.InvoicesID,
        InvoicesNumber: item.InvoicesNumber,
        Amount: item?.Amount,
        PaymentStatusName: item?.PaymentStatusName,
        SubmittedBy: item?.SubmitedBy,
        Submitteddate: item?.Submiteddate,
        PaymentStatus: item?.PaymentStatus,
        clientName: item?.clientName,
        InvoiceStatusName: item?.InvoiceStatusName,


    }));


    // Open INVOICE ViewList modal
    const handleInvoiceModal = async (invoiceId, actionType) => {
        if (actionType === 'view' && invoiceId) {
            const params = {
                invoicesID: invoiceId,
            }

            try {
                setIsLoading(true);
                const response = await get_schedule_Invoice_Details(params)
                if (response?.data?.status === "success") {
                    setInvoiceList(response?.data?.data)
                    handleViewInvoiceModal(true);
                } else {
                    ErrorToast(response?.data?.message || `Something Went Wrong!`)
                }
            } catch (error) {

            } finally {
                setIsLoading(false)
            }
        }
    };
    // HANDLE VIEW INVOICE MODAL
    const handleViewInvoiceModal = (isOpen) => {
        setViewModal(isOpen);
    };


    // 
    const changeInvoiceStatus = async (values) => {

        const params = {
            paymentStatus: values?.paymentStatus,
            description: values?.description,
            invoices_id: selectedIds?.length > 0 ? JSON.stringify(selectedIds) : ''

            // invoices_id: selectedIds?.length > 0 ? JSON.stringify(selectedIds) : JSON.stringify([invoiceId])
        }

        try {
            setIsButtonDisabled(true);
            const response = await change_invoice_status(params);
            const message = response?.data?.message || 'Something went wrong!';
            if (response?.data?.status === "success") {
                SuccessToast(message);
                setRefresh(!refresh);
                setSelectedIds([]);
                closePaymentSubmitModal()
            } else {
                ErrorToast(message);
            }
        } catch (error) {
            const errorMessage = error?.data?.errors ? Object.values(error.data.errors)[0][0] : 'Something went wrong!';
            ErrorToast(errorMessage);
        } finally {
            setIsButtonDisabled(false);
        }
    };

    // reports forward to client
    const handleForwardToClient = async () => {
        const params = {
            invoices_id: JSON.stringify(selectedIds),
        }

        try {
            setIsButtonDisabled(true);
            const response = await invoice_move_to_finance(params)
            if (response?.data?.status === "success") {
                SuccessToast(response?.data?.message)
                setRefresh(!refresh)
                handleSubmitModal(false, "")
            } else {
                ErrorToast(response?.data?.message || `Something Went Wrong!`)
            }
        } catch (error) {

        } finally {
            setIsButtonDisabled(false);
        }
    }


    // Handle pagination changes
    const handlePageChange = (pageNumber) => setPageNumber(pageNumber);
    const handleItemPageCountChange = (pageItemCount) => setTotalItemPerPage(pageItemCount);

    // Handle search filter changes and update filter values
    const handleSearchFilter = (filterValues) => {
        setFilterValues(filterValues);
    };

    // FOR HANDLE THE CHECKBOX WHEN INVOICE AND PAYMENT BUTTON HJIDE AND SHOW BASED ON THE DROPDOWN
    const handleCurrentDropdownValues = (Values) => {
        setcurrentDropdown(Values);

        setFilterValues((prev) => ({
            ...prev, // keep old values
            PaymentStatus: Values.PaymentStatus,
            sentToClient: Values.sentToClient,
        }));
    };
    // Function to handle OPEN/CLOSE CLIENT MODAL 
    const handleSubmitModal = (isOpen, id = '') => {
        setSubmitModal({ isOpen, id })
    }

    // Function to handle HIDE/SHOW DELETE MODAL
    const handlPaymentSubmitModal = (isOpen, id = '') => {
        setPaySubmitModal({ isOpen, id })
    }

    // Close modal
    const closePaymentSubmitModal = () => {
        setPaySubmitModal({ id: '', isOpen: false });
    };

    // FOR SELECET ALL FUNCTION
    const handleSelectAll = (isChecked) => {

        if (isChecked) {
            const allIds = rows()?.map((row) => row.id);
            setSelectedIds(allIds);
        } else {
            setSelectedIds([]);
        }
    };


    // FOR SELECT SCHEDULE BY ROW
    const handleSelectRow = (id) => {
        setSelectedIds((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((itemId) => itemId !== id)
                : [...prevSelected, id]
        );
    };
    const handleClearSelectedIds = () => {
        setSelectedIds([])
    }

    // HISTORY BUTTON CLICK AND API CALL
    const handleHistoryModal = async (open, id) => {
        setShowHistory(open);

        if (open) {
            setHistoryLoader(true);
            try {
                const response = await fetchHistoryData('invoice', id);
                if (response?.status === "success") {

                    //  Transform API response for  table usage
                    const formatted = response?.data?.map((item, index) => ({
                        id: item.id,
                        name: item.name || "-",
                        changedBy: item.changed_by_name || "Unknown",
                        changedAt: item.changed_at || "-",
                        changeDescription: item.change_description || "-",
                    }));

                    setHistoryData(formatted || []);
                } else {
                    // InfoToast("No history data found.");
                    setHistoryData([]);
                }
            } catch (error) {
                console.error("Error fetching project history:", error);
            } finally {
                setHistoryLoader(false);
            }
        } else {
            setHistoryData([]);
        }
    };


    //FOR CHECK BOX SHOW BASED ON PRIVILEGE IN THE TABLE
    let isCheckbox = false;

    if (currentDropdown.PaymentStatus === 0 && currentDropdown.sentToClient === 1) {
        isCheckbox = userPermissions.Mark_as_paid;

    }
    else if (currentDropdown.sentToClient === 0) {
        isCheckbox = userPermissions.Send_to_client;
    }

    return (
        <>
            <div className='workforce-management-table-container'>
                <InvoiceSearchFilter
                    tableTitle={`Invoice`}
                    // isAddEditModalOpen={modalProps.isOpen}
                    searchFilter={handleSearchFilter}

                    IscheckBoxEnable={isCheckbox}
                    handlPaymentSubmitModal={handlPaymentSubmitModal}
                    handleForwardToClient={handleForwardToClient}
                    filterValues={filterValues}
                    handleClearSelectedIds={handleClearSelectedIds}
                    handleSubmitModal={handleSubmitModal}

                    on_change_value={handlePageChange}
                    on_page_count_update={handleItemPageCountChange}

                    is_SendTo_Client={userPermissions.Send_to_client && selectedIds?.length > 0}
                    is_Mark_As_Paid={userPermissions.Mark_as_paid && selectedIds?.length > 0}

                    handleCurrentDropdownValues={handleCurrentDropdownValues}
                    currentDropdown={currentDropdown}
                />
                <div>
                    <CustomTable
                        columns={columns}
                        rows={isLoading ? [] : rows()}
                        renderActions={renderActions}
                        isCheckbox={isCheckbox}
                        selectedIds={selectedIds}
                        handleSelectAll={handleSelectAll}
                        handleSelectRow={handleSelectRow}
                        isLoading={isLoading}
                    />
                </div>
                <div className='bottom-container'>
                    {isLoading ? <Loader /> : <CustomBottomPagination
                        items_per_page={totalItemPerPage}
                        current_page={pageNumber}
                        total_page_count={totalPages}
                        on_change_value={handlePageChange}
                        on_page_count_update={handleItemPageCountChange}
                        pagination={pagination}
                    />}
                </div>
            </div>

            {/* Submit to Client */}
            <CustomConfirmModal
                custom_text={'Want to submit this to the Client?'}
                open_modal={submitModal?.isOpen}
                close_modal={handleSubmitModal}
                confirm_function={handleForwardToClient}
                isButtonDisabled={isButtonDisabled}
            />

            {/*  Invoice View */}
            <CustomModal
                open={viewModal}
                handleClose={() => handleViewInvoiceModal(false)}
                title_other=""
                title={"Invoice Summary"}
                body={
                    <InvoiceListView
                        invoiceList={invoiceList}
                    />
                }
                maxWidth="800px"
            />
            {/*   Pay Modal */}
            <CustomModal
                open={paySubmitModal.isOpen}
                handleClose={closePaymentSubmitModal}
                title_other=""
                title={"Change Status"}
                body={
                    <UpdatePaymentStatusForm
                        id={paySubmitModal?.id}
                        handleSave={changeInvoiceStatus}
                        isButtonDisabled={isButtonDisabled}

                    />
                }
                maxWidth="600px"
            />

            {showHistory && <CustomModal
                open={showHistory}
                handleClose={() => handleHistoryModal(false)}
                title="Invoice History"
                maxWidth="75%"
                body={
                    historyLoader ? (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                            <Loader />
                        </div>
                    ) : (
                        <ActionHistory
                            title=""
                            data={historyData}
                            columns={[
                                { key: "name", label: "Invoice" },
                                { key: "changedBy", label: "Changed By" },
                                { key: "changedAt", label: "Changed At" },
                                { key: "changeDescription", label: "Change Description" },
                            ]}
                            noDataMessage="No change history available."
                        />

                    )
                }
            />}

        </>
    )
}

export default InvoiceTable